import { createStandardAction } from 'typesafe-actions';

import type { PageLoading } from 'PageLoading-Types';

export const setLoadingStatus = createStandardAction('SET_LOADING_STATUS').map(
  (payload: PageLoading) => ({
    payload,
  }),
);
